// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3315":"css/admin-app.6854","9558":"css/app.6854"}[chunkId] + ".css";
};